import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MigrationService } from '../../migration/migration.service';
import { OnboardingService } from '../../onboarding/onboarding.service';
import { PersonService } from '../../personnel/person.service';
import { ConnectionService } from '../../shared/services/connection/connection.service';
import { FieldService } from '../../shared/services/fields/field.service';
import { ManageSeasonsService } from '../season-selector/manage-seasons/manage-seasons.service';
import { AnimalService } from './animal/animal.service';
import { ApiService } from './api/api.service';
import { AuthConsoleApiService } from './auth-console-api/auth-console-api.service';
import { AuthorisationService } from './authorisation/authorisation.service';
import { BusinessService } from './business/business.service';
import { CompanyService } from './company/company.service';
import { ActivityListService } from './cost/activity-list.service';
import { CostService } from './cost/cost.service';
import { CroppingRecordsService } from './cropping-records/cropping-records.service';
import { EmailService } from './email/email.service';
import { EnvService } from './env/env.service';
import { FeatureService } from './feature/feature.service';
import { FertiliserService } from './fertiliser/fertiliser.service';
import { FieldSummaryService } from './field-summary/field-summary.service';
import { FieldCroppingService } from './fields/field-cropping.service';
import { HoldingService } from './holdings/holding.service';
import { ImpersonateService } from './impersonate/impersonate.service';
import { ImplementsService } from './implements/implements.service';
import { InspectionsService } from './inspections/inspections.service';
import { IntercomService } from './intercom/intercom.service';
import { JobsService } from './jobs/jobs.service';
import { LocationConverterService } from './location-converter/location-converter.service';
import { LookupsService } from './lookups/lookups.service';
import { MachinesService } from './machines/machines.service';
import { MessageService } from './message/message.service';
import { ModalDialogService } from './modal-dialog/modal-dialog.service';
import { NutrientLivestockPlanAnimalService } from './nutrient-livestock-plan-animal/nutrient-livestock-plan-animal.service';
import { NutrientLivestockPlanResultsService } from './nutrient-livestock-plan-results/nutrient-livestock-plan-results.service';
import { NutrientLivestockPlanTransferService } from './nutrient-livestock-plan-transfer/nutrient-livestock-plan-transfer.service';
import { NutrientLivestockPlanService } from './nutrient-livestock-plan/nutrient-livestock-plan.service';
import { NutrientPlanGroupService } from './nutrient-plan-group/nutrient-plan-group.service';
import { NutrientSlurryPlanExcretaCollectionService } from './nutrient-slurry-plan-excreta-collection/nutrient-slurry-plan-excreta-collection.service';
import { NutrientSlurryPlanExportAndAdjustmentService } from './nutrient-slurry-plan-export-and-adjustment/nutrient-slurry-plan-export-and-adjustment.service';
import { NutrientSlurryPlanRainfallCollectionService } from './nutrient-slurry-plan-rainfall-collection/nutrient-slurry-plan-rainfall-collection.service';
import { NutrientSlurryPlanStoreService } from './nutrient-slurry-plan-store/nutrient-slurry-plan-store.service';
import { NutrientSlurryPlanWashWaterCollectionService } from './nutrient-slurry-plan-wash-water-collection/nutrient-slurry-plan-wash-water-collection.service';
import { NutrientSlurryPlanService } from './nutrient-slurry-plan/nutrient-slurry-plan.service';
import { ParamsService } from './params/params.service';
import { PrescriptionService } from './products/prescription.service';
import { ProductService } from './products/product.service';
import { RecommendationServiceV2 } from './recommendation/recomendation.service.v2';
import { ReportService } from './report/report.service';
import { SeasonService } from './season/season.service';
import { SignalRService } from './signalr/signalr.service';
import { SoilNutrientIndexService } from './soil-nutrient-index/soil-nutrient-index.service';
import { StockAuditService } from './stock/stock-audit.service';
import { StockOverviewService } from './stock/stock-overview.service';
import { TagService } from './tags/tag.service';
import { TelerikService } from './telerik/telerik.service';
import { TradeTypeListService } from './trade-types/trade-type-list.service';
import { TradeCroppingRecordsService } from './trades/trade-cropping-records.service';
import { TradeProductsService } from './trades/trade-product.service';
import { TradesService } from './trades/trades.service';
import { UpdateNotifierService } from './update/update-notifier.service';
import { UserService } from './user/user.service';
import { ValidationExpressionService } from './validation-expression/validation-expression.service';
import { WeatherService } from './weather/weather.service';
import { WorkHeadersService } from './work-orders/work-headers.service';
import { WorkOrderGroupService } from './work-orders/work-order-groups.service';
import { WorkOrderOperationsService } from './work-orders/work-order-operations.service';
import { WorkOrdersService } from './work-orders/work-orders.service';
import { WorkRecordHseCheckListsService } from './work-orders/work-record-hsechecklists.service';
import { WorkRecordOperationProductsService } from './work-orders/work-record-operation-products.service';
import { WorkRecordOperationsService } from './work-orders/work-record-operations.service';
import { WorkRecordsService } from './work-orders/work-records.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  exports: [],
  providers: [
    BusinessService,
    FieldService,
    LookupsService,
    ManageSeasonsService,
    CostService,
    AuthorisationService,
    LocationConverterService,
    MessageService,
    ModalDialogService,
    RecommendationServiceV2,
    ReportService,
    SeasonService,
    UserService,
    ValidationExpressionService,
    TelerikService,
    UpdateNotifierService,
    ApiService,
    CompanyService,
    ParamsService,
    HoldingService,
    ProductService,
    FertiliserService,
    ConnectionService,
    WorkOrdersService,
    WorkOrderGroupService,
    WorkOrderOperationsService,
    WorkRecordsService,
    WorkRecordOperationsService,
    WorkRecordHseCheckListsService,
    WorkRecordOperationProductsService,
    MachinesService,
    ImplementsService,
    PrescriptionService,
    IntercomService,
    ActivityListService,
    FieldCroppingService,
    InspectionsService,
    StockAuditService,
    StockOverviewService,
    TradeTypeListService,
    TradeProductsService,
    TradesService,
    CroppingRecordsService,
    TradeCroppingRecordsService,
    WorkHeadersService,
    WeatherService,
    EnvService,
    TagService,
    FeatureService,
    FieldSummaryService,
    ImpersonateService,
    EmailService,
    PersonService,
    OnboardingService,
    MigrationService,
    JobsService,
    AuthConsoleApiService,
    NutrientPlanGroupService,
    NutrientLivestockPlanService,
    AnimalService,
    NutrientLivestockPlanAnimalService,
    NutrientLivestockPlanTransferService,
    NutrientSlurryPlanService,
    NutrientSlurryPlanExcretaCollectionService,
    SoilNutrientIndexService,
    NutrientSlurryPlanStoreService,
    NutrientLivestockPlanResultsService,
    NutrientSlurryPlanRainfallCollectionService,
    NutrientSlurryPlanWashWaterCollectionService,
    NutrientSlurryPlanExportAndAdjustmentService,
    SignalRService
  ]
})
export class SharedServicesModule {}
